export default "__VITE_ASSET__C48PdXnL__"